// ===== uk-weather.js =====
document.addEventListener("DOMContentLoaded", function() {
  const apiKey = "39384f0148f132447e6ae33e6533b5fb"; // 你的 OpenWeatherMap API key
  const city = "London,GB";
  const apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&units=metric&appid=${apiKey}&lang=zh_cn`;

  fetch(apiUrl)
    .then(res => res.json())
    .then(data => {
      const tempEl = document.getElementById("london-temp");
      const descEl = document.getElementById("weather-desc");
      const humidityEl = document.getElementById("humidity");
      const windEl = document.getElementById("wind-speed");
      const iconEl = document.getElementById("weather-icon");

      if (!data || !data.main) {
        throw new Error("Invalid data");
      }

      tempEl.textContent = Math.round(data.main.temp) + "°C";
      descEl.textContent = data.weather[0].description;
      humidityEl.textContent = data.main.humidity + "%";
      windEl.textContent = Math.round(data.wind.speed * 3.6) + " km/h";

      let icon = data.weather[0].main.toLowerCase();
      let iconClass = "fas fa-cloud";
      if (icon.includes("clear")) iconClass = "fas fa-sun";
      else if (icon.includes("rain")) iconClass = "fas fa-cloud-rain";
      else if (icon.includes("cloud")) iconClass = "fas fa-cloud-sun";
      else if (icon.includes("snow")) iconClass = "fas fa-snowflake";
      else if (icon.includes("fog") || icon.includes("mist")) iconClass = "fas fa-smog";

      iconEl.innerHTML = `<i class="${iconClass}"></i>`;
    })
    .catch(() => {
      document.getElementById("london-temp").textContent = "12°C";
      document.getElementById("weather-desc").textContent = "暂时无法获取天气数据";
      document.getElementById("humidity").textContent = "78%";
      document.getElementById("wind-speed").textContent = "15 km/h";
    });
});
